import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Form, Table, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {downloadFile} from '../../../common/util/file';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {buildParameters} from '../../utils';
import WarrantiesCampaignTable from './WarrantiesCampaignTable';
import SearchForm from './SearchForm';
import './styles.scss';

const INITIAL_STATE = {
  'attendedDealer': 'TODOS',
  'asignedDealer': 'TODOS',
  'campaignNo': 'TODOS',
  'status': 'TODOS',
  'startDate': null,
  'endDate': null,
  'taskId': '',
};

class WarrantyCampaignsReport extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarrantyCampaignsReport,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
    this.props.fetchCampaignList({'status': 'A'});
  }

  componentDidUpdate() {
    const {warrantyCampaignExcelFile} = this.props;

    if (warrantyCampaignExcelFile) {
      downloadFile(warrantyCampaignExcelFile);
      this.props.clearWarrantyCampaignsExcelFile();
    }
  }

  componentWillUnmount() {
    this.props.clearwarrantyCampaigns();
  }

  handleSearch = () => {
    const params = buildParameters(this.state);
    this.props.fetchWarrantyCampaigns(params);
  };

  handleChange = (e, {name, value}) => {
    this.setState({[name]: value});
  };

  handleChangeDate = (field, date) => {
    this.setState({[field]: date});
  };

  handleClear = () => {
    this.setState(INITIAL_STATE);
    this.props.clearwarrantyCampaigns();
  };

  handleExportClick = () => {
    const params = buildParameters(this.state);
    this.props.downloadWarrantyCampaignsExcel(params);
  };

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader
                active
                inline='centered'
                content='Cargando resultados...'
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {
      loading,
      dealersList,
      campaignList,
      loadingExcelFile,
      warrantyCampaignsList,
    } = this.props;

    return (
      <div className='campaign-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Reporte de Garantias en Campañas</h2>
              <div className='title-bar-actions'>
                <Button
                  primary
                  icon='download'
                  content='EXPORTAR'
                  loading={loadingExcelFile}
                  disabled={loading}
                  onClick={this.handleExportClick}
                />
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className='search-container'>
            <Form>
              <label className='search-label'>
                Búsqueda de garantias de campañas
              </label>
              <SearchForm
                {...this.state}
                loading={loading}
                disabled={loadingExcelFile}
                dealersList={dealersList}
                campaignList={campaignList}
                handleClear={this.handleClear}
                handleChange={this.handleChange}
                handleSearch={this.handleSearch}
                handleChangeDate={this.handleChangeDate}
              />
            </Form>
          </div>
        </Card>
        <Card raised fluid className='warranty-campaigns-table'>
          {loading ? (
            this.renderLoader()
          ) : (
            <WarrantiesCampaignTable dataTable={warrantyCampaignsList} />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingDealers': state.dealer.loading,
    'dealersList': state.dealer.list,
    'permissions': state.session.permissions,
    'isUserTde': state.session.isUserFromTDE,
    'campaignList': state.campaignList.list,
    'loading': state.warrantyCampaigns.loading,
    'warrantyCampaignsList': state.warrantyCampaigns.list,
    'loadingExcelFile': state.warrantyCampaigns.loadingExcelFile,
    'warrantyCampaignExcelFile': state.warrantyCampaigns.excelFile,
  };
};

const {
  withRouter,
  navigateTo,
  fetchDealers,
  fetchCampaignList,
  clearwarrantyCampaigns,
  fetchWarrantyCampaigns,
  downloadWarrantyCampaignsExcel,
  clearWarrantyCampaignsExcelFile,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  fetchDealers,
  fetchCampaignList,
  clearwarrantyCampaigns,
  fetchWarrantyCampaigns,
  downloadWarrantyCampaignsExcel,
  clearWarrantyCampaignsExcelFile,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(WarrantyCampaignsReport));
